<br />
<br />
<br />
<br />
<br />
<br />
<!--<h1 style="text-align:center">viper:freight</h1>-->

<!--<md-checkbox>test check</md-checkbox>-->
<img class="center" [src]="appSettingsService.companyLogo" />